module.exports = __webpack_public_path__ + "img/logo-safe-medical.0d62cf59.png";